import { useState, useEffect } from "react";
import "./SignUpPageComponent.css";

export default function SignUpPageComponent() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    // Always start at top
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    setSubmitted(true);
  };

  return (
    <main className="signup-page mtc">
      {/* Hero */}
      <section className="signup-hero">
        <h1 className="signup-title">Create an Account</h1>
        <p className="signup-sub">
          Sign up to access Myris Tech’s secure software and mission resources.
        </p>
      </section>

      <hr className="mtc-hairline" />

      {/* Form Section */}
      <section className="signup-form-wrapper">
        {!submitted ? (
          <form className="signup-form" onSubmit={handleSubmit}>
            <label>
              Full Name
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Email
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Password
              <input
                type="password"
                name="password"
                value={form.password}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Confirm Password
              <input
                type="password"
                name="confirmPassword"
                value={form.confirmPassword}
                onChange={handleChange}
                required
              />
            </label>

            <button type="submit" className="signup-btn">Sign Up</button>
          </form>
        ) : (
          <div className="signup-success">
            <h2>Welcome aboard!</h2>
            <p>
              Your account has been created successfully. You can now sign in
              to access Myris Tech tools and systems.
            </p>
          </div>
        )}
      </section>
    </main>
  );
}
